import {Component, ElementRef, inject, OnInit, signal, TemplateRef, ViewChild} from '@angular/core';
import {PaginatedDataResponse} from '../../models/response/PaginatedDataResponse';
import {Export} from '../../models/Export';
import {DatePipe} from '@angular/common';
import {ExportService} from '../../services/export.service';
import {UntypedFormBuilder} from '@angular/forms';
import {Order} from '../../models/Order';
import {Pagination} from '../../models/Pagination';
import {HttpErrorResponse} from '@angular/common/http';
import {DownloadService} from '../../services/download.service';
import {ToastService} from '../../services/toast.service';
import {SortButtonComponent} from '../../layout/sort-button/sort-button.component';
import {PaginationComponent} from '../../layout/pagination/pagination.component';
import {DirectionType} from '../../enum/DirectionType';
import {PaginationStorageService} from '../../services/pagination-storage.service';

type ServiceType = Export;

@Component({
  selector: 'app-export-log',
  imports: [
    DatePipe,
    SortButtonComponent,
    PaginationComponent
  ],
  templateUrl: './exports.component.html',
  styles: ``
})
export class ExportsComponent implements OnInit {
  private service = inject(ExportService);
  private fb = inject(UntypedFormBuilder);
  private download = inject(DownloadService);
  private toast = inject(ToastService);
  private pagination = inject(PaginationStorageService);

  @ViewChild('trashModal') trashModalRef?: ElementRef;

  public deleteId = signal<number | undefined>(undefined);

  public paginatedResponse = signal<PaginatedDataResponse<ServiceType>>(new PaginatedDataResponse<ServiceType>());
  public elementsPerPage = signal<number>(10);
  public order = new Order('created_at', DirectionType.desc);
  public formSearch = this.fb.group({});

  ngOnInit(): void {
    this.elementsPerPage.set(this.pagination.getElements());
    this.updateList();
  }

  updateList(pagination: Pagination = {page: 1, elements: this.elementsPerPage()}): void {
    const value: ServiceType = this.formSearch.value;
    this.service.index(
      pagination.elements,
      pagination.page,
      value,
      this.order,
      ['user']
    ).subscribe((response) => {
        this.paginatedResponse.set(response.data);
    });
  }

  onDownload(item: Export): void {
    if (!item.id) {
      console.error('Id mancante');
      this.toast.error('Errore nel recupero dei dati');
      return;
    }
    if (!item.download_extension) {
      console.error('Estensione mancante');
      this.toast.error('Errore nel recupero dei dati');
      return;
    }
    this.service.download(item?.id)
      .subscribe({
        next: (result) => {
          this.toast.success('Export scaricato');
          this.download.downloadBlobFile(result, item.download_name ?? 'Export', '.' + item.download_extension);
        },
        error: (error: HttpErrorResponse) => {
          this.toast.error('Errore durante il download');
        }
      });
  }

  openTrashModal(item: Export): void {
    this.deleteId.set(undefined);
    if (!item.id) {
      console.error('Id mancante');
      this.toast.error('Errore nel recupero dei dati');
      return;
    }
    this.deleteId.set(item.id);
    this.trashModalRef?.nativeElement.showModal();
  }

  destroy(modal: HTMLDialogElement): void {
    if (this.deleteId()) {
      modal.close();
      this.service.destroy(this.deleteId() as number).subscribe({
        next: () => {
          this.toast.success('Cancellazione avvenuta');
          this.updateList();
        },
        error: (error: HttpErrorResponse) => {
          this.toast.error('Errore durante la cancellazione');
        }
      });
    }
  }

  onElementsChange(elements: number): void{
    this.elementsPerPage.set(elements);
  }
}
